import useSWR from 'swr';
import { fetcher } from '../lib/fetcher';
import { useAppBridge } from '@shopify/app-bridge-react';

export default function useUser() {
  const app = useAppBridge();
  const { data, mutate, error, isValidating } = useSWR<any>(
    `${process.env.APP_URL}/api/users`,
    (input) => fetcher(app, input),
    {
      revalidateOnReconnect: false,
      revalidateOnFocus: false,
      shouldRetryOnError: false,
    },
  );

  const loading = !data && !error;
  const loggedOut = isValidating ? false : error ? error.statusCode === 401 : false;

  const updateRequired = data && data.updateRequired;

  return {
    loading,
    loggedOut,
    user: data,
    mutate,
    updateRequired,
  };
}
